import { Injectable } from '@angular/core';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  constructor() {
    const app = initializeApp(firebaseConfig);
    getAnalytics(app);
  }

  logCustomEvent(eventName: string, params?: { [key: string]: any }) {
    const analytics = getAnalytics();
    logEvent(analytics, eventName, params);
  }
}
